import { Injectable } from '@angular/core';
import { TimeService } from '@bayclubs/utils';
import moment from 'moment';

@Injectable()
export class SessionsWeeksService {
    constructor(private time: TimeService) {}

    createSessionWeeks(sessions: any[]): SessionsWeek[] {
        const weeks: SessionsWeek[] = [];

        sessions.forEach((session) => {
            const newWeek = new SessionsWeek(this.time.toMoment(session.from));

            const existing = weeks.filter((group: SessionsWeek) => {
                return group.isTheSameAs(newWeek);
            });

            if (existing && existing[0]) {
                existing[0].addSession(session);
            } else {
                newWeek.addSession(session);
                weeks.push(newWeek);
            }
        });

        return weeks.sort((a, b) => {
            return a.dateStart.diff(b.dateStart, 'minutes');
        });
    }
}

export class SessionsWeek {
    sessions: any[] = [];
    dateStart: moment.Moment;

    public month: number;
    public year: number;
    public week: number;
    public title: string;

    constructor(date: moment.Moment) {
        this.sessions = [];
        this.dateStart = date.startOf('isoWeek');
        this.year = this.dateStart.year();
        this.month = this.dateStart.month();
        this.week = this.dateStart.week();

        this.title =
            'Week: ' +
            this.dateStart.format('MMM Do') +
            ' - ' +
            this.dateStart.add(4, 'days').format('Do');
    }

    public addSession(session: any) {
        this.sessions.push(session);
    }

    public isTheSameAs(other: SessionsWeek): boolean {
        return (
            other.month === this.month &&
            other.year === this.year &&
            other.week === this.week
        );
    }
}
